const useSwapMainText = (): string[] => [
  'Curate your own products and shopping experience.',
  'Take your credit and shop anytime',
];

export default useSwapMainText;
